import {DateSelector} from '../DateTimeSelector/DateSelector';
import styles from './ExactTimeSelector.module.css';

interface IExactTimeSelector {
    startDate: Date|null;
    setStartDate: (date: Date|null) => void;
    endDate: Date|null;
    setEndDate: (date: Date|null) => void;
}

export const ExactTimeSelector = ({startDate, setStartDate, endDate, setEndDate}: IExactTimeSelector) => {
    return (
        <div className={styles.container}>
            <DateSelector date={startDate} setDate={setStartDate} highlighted={true}/>
            &nbsp;-&nbsp;
            <DateSelector date={endDate} setDate={setEndDate} highlighted={true}/>
        </div>
    );
};
